var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonBinary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287.867 260V161.553L332.174 187.134L364.041 131.938L319.734 106.357L364.041 80.776L332.174 25.58L287.867 51.161V0H224.133V51.162L179.826 25.581L147.959 80.777L192.266 106.358L147.959 131.939L179.826 187.135L224.133 161.554V260C168.858 274.163 128 324.309 128 384C128 454.692 185.307 512 256 512C326.692 512 384 454.692 384 384C384 324.31 343.142 274.163 287.867 260ZM256 448.266C220.564 448.266 191.734 419.437 191.734 384C191.734 348.563 220.563 319.734 256 319.734C291.437 319.734 320.266 348.563 320.266 384C320.266 419.437 291.436 448.266 256 448.266Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonBinary);
export default __webpack_public_path__ + "static/media/Non Binary.3ee3ab3d0e8f75cb9cbe8c9ba99d974e.svg";
export { ForwardRef as ReactComponent };